import { LocationDirtworkCostBase } from './base/location-dirtwork-cost-base';

export class LocationDirtworkCost extends LocationDirtworkCostBase { }